<!-- eslint-disable no-case-declarations -->
<template>
  <div>
    <div class="f-e" v-if="isEmptyDataAll && orderStatus === 'waiting_payment'" style="padding: 6px 20px 6px 0;border-bottom: 4px solid rgba(205, 212, 221, 0.22);">
      <div style="margin-left: 6px;font-size: 16px;">
        {{ $t('Order.List.Components.AllStatus.AutoCheckout') }}
        <el-switch v-model="ifAutomaticPayment" @change="switchPaymentHandle" />
      </div>
    </div>
    <template v-if="!isEmptyDataAll">
      <listTopFilter @getList="resetPage" :orderStatus="orderStatus" ref="listTopFilter"></listTopFilter>
      <div  class="f-b-c" style="padding: 0 20px 0">
        <div class="f--c">
          <div style="margin-right: 8px">
            <el-checkbox v-model="isAllChecked" @change="allCheck" style="margin-right: 14px">{{ $t('orderList.selectAll') }}</el-checkbox>
            <div style="padding-left: 24px" v-if="orderIsHaveChoice">{{ selectionForPayNow.length }} {{ $t('Order.List.Components.AllStatus.OrdersSelected') }}</div>
          </div>
          <div class="pointer payNowBatch f--c" style="" @click="checkEmailBindBatch" v-if="orderStatus === 'waiting_payment' && orderIsHaveChoice">{{ $t('orderList.PayNow') }}</div>
          <div style="background-color: rgba(205, 212, 221, 0.22); height: 28px; width: 28px" class="f-c-c pointer" @click="allExport(2)" v-if="orderIsHaveChoice">
            <i class="el-icon-download" style="font-size: 20px" :style="{color: orderIsHaveChoice? '#99C41C': '#333', background: orderIsHaveChoice ? '#F8FBEF': 'rgba(205, 212, 221, 0.22)'}"></i>
          </div>
        </div>
        <div v-if="orderStatus === 'waiting_payment'" class="f--c">
          <el-popover placement="top-end" width="360" trigger="hover">
            <div>{{ $t('Order.List.Components.AllStatus.Tips1') }} <el-button type="text" style="padding: 0">{{ $t('Order.List.Components.AllStatus.Tips2') }}</el-button> {{ $t('Order.List.Components.AllStatus.Tips3') }}</div>
            <i class="iconfont icon-help pointer" slot="reference"></i>
          </el-popover>
          <div style="margin-left: 6px;font-size: 16px;">
            {{ $t('Order.List.Components.AllStatus.AutoCheckout') }}
            <el-switch v-model="ifAutomaticPayment" @change="switchPaymentHandle" />
          </div>
        </div>
      </div>
      <div style="padding: 14px 20px">
        {{ $t('orderList.YouHave') }} <span style="color: #99c41c">{{ total }}</span> {{ $t('orderList.orders') }}
      </div>
      <div class="orderGroup">
        <template v-if="!isEmptyDataWithParams">
          <div class="orderGroup_item" v-for="(item, index) in listData" :key="index">
            <div class="f-b" style="background-color: #fafafa; padding: 6px 20px 6px 4px">
              <div class="f--c left" style="height: 48px">
                <div style="margin-right: 8px">
                  <el-checkbox @change="(value) => itemCheck(item, value)" :disabled="item.orderType === 5" v-model="item.isChecked"></el-checkbox>
                </div>
                <div style="width: 200px">
                  <div class="f">
                    <img src="@/assets/img/shopify-store.png" style="width: 16px; height: 16px; margin-right: 4px" v-if="item.platformCode === 'SP'" />
                    <img src="@/assets/img/kakaclo-store.png" style="width: 16px; height: 16px; margin-right: 4px" v-if="item.platformCode === 'KA'" />
                    <img src="@/assets/img/dianjiang-store.png" style="width: 16px; height: 16px; margin-right: 4px" v-if="item.platformCode === 'DJ'" />
                    <img src="@/assets/img/shopline.png" style="width: 16px; height: 16px; margin-right: 4px" v-if="item.platformCode === 'SL'" />
                    <img src="@/assets/img/woocommerce.png" style="width: 16px; height: 16px; margin-right: 4px" v-if="item.platformCode === 'WC'" />
                    <img src="@/assets/img/tiktok.png" style="width: 16px; height: 16px; margin-right: 4px" v-if="item.platformCode === 'TT'" />
                    <span>{{ item.platformName }}</span>
                  </div>
                  <div>{{ item.purchaseDate | dateFormat }}</div>
                </div>
                <div style="width: 200px">
                  <div>{{ $t('orderList.OrderID') }}</div>
                  <div>{{ item.kkOrderId }}</div>
                </div>
                <div style="width: 160px" v-if="item.storeName">
                  <div>{{ $t('Order.List.Components.AllStatus.Source') }}</div>
                  <div>{{ item.storeName }}</div>
                </div>
                <div style="width: 180px" v-if="item.storeOrderId">
                  <div>{{ $t('Order.List.Components.AllStatus.StoreOrderID') }}</div>
                  <div>{{ item.storeOrderId }}</div>
                </div>
                <div style="width: 160px">
                  <div>{{ $t('orderList.Customer') }}</div>
                  <div>{{ item.customer }}</div>
                </div>
                <div style="width: 160px" v-if="item.couponCode">
                  <div>{{ $t('orderList.coupon') }}</div>
                  <div>{{ item.couponCode }}</div>
                </div>
                <div style="width: 160px" v-if="item.totalAmount">
                  <div>{{ $t('orderList.TotalAmount') }}</div>
                  <div>US${{ item.totalAmount.toFixed(2) }}</div>
                </div>
                <div>
                  <!-- {{item.orderStatusName}} -->
                </div>
              </div>
              <div class="f--c right" style="height: 48px">
                <el-button round type="primary" @click="checkEmailBind(item)" v-if="item.orderStatus == 0">{{ $t('orderList.PayNow') }}</el-button>
              </div>
            </div>
            <div class="f-b">
              <div>
                <div style="padding: 10px 20px" class="detailInfo f" v-for="(product, productIndex) in item.orderItemRender" :key="product.skuCode">
                  <!-- 配件 好评卡 -->
                  <template v-if="product.type === 'Cards'">
                    <div style="margin: 0 10px 0 0; width: 500px">
                      <div class="f" style="margin-bottom: 8px; font-size: 13px; color: #747a87">
                        <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
                      </div>
                      <div style="width: 322px" class="f">
                        <el-popover placement="right" width="280" trigger="hover">
                          <el-image fit="cover" :src="product.imageUrl"></el-image>
                          <div style="position: relative; width: 70px; height: 70px; border-radius: 6px; margin-right: 8px" slot="reference">
                            <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl"></el-image>
                          </div>
                        </el-popover>
                        <div class="imageInfo" style="width: 256px">
                          <el-tooltip effect="dark" :content="product.name" placement="top">
                            <div style="margin-bottom:24px">{{ product.name }}</div>
                          </el-tooltip>
                          <div>$0</div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div style="margin: 0 10px 0 0; width: 500px">
                      <div class="f" style="margin-bottom: 8px; font-size: 13px; color: #747a87">
                        <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
                        <el-popover v-if="product.attachmentSkuVos && product.attachmentSkuVos.length && product.attachmentSkuVos.filter(t => t.type !== 'Cards').length" placement="bottom" width="360" trigger="hover">
                          <div class="partsTable">
                            <p>{{ $t('Order.List.Components.AllStatus.Accessories') }}</p>
                            <template v-for="item in product.attachmentSkuVos">
                              <div v-if="item.type !== 'Cards'" :key="item.type+`_${item.id}`" class="f productBox">
                                <div class="imageBox">
                                  <el-image :src="item.imageUrl" style="height: 52px; width: 52px"></el-image>
                                </div>
                                <div class="f-b fd-c info">
                                  <p>{{ item.name }}</p>
                                  <p>x {{ product.productNum }}</p>
                                </div>
                              </div>
                            </template>
                          </div>
                          <i class="icon-pinpaitemai-tianchong iconfont myAttachemtIcon" style="color: #99c41c; margin-right: 8px" slot="reference"></i>
                        </el-popover>
                        <div v-if="product.sellerSku && item.platformCode !== 'KA'">{{ $t('Order.List.Components.AllStatus.StoreSKU') }}：{{ product.sellerSku }}</div>
                      </div>
                      <div style="width: 322px" class="f">
                        <el-popover placement="right" width="280" trigger="hover">
                          <el-image fit="cover" :src="product.imageUrl"></el-image>
                          <div style="position: relative; width: 70px; height: 70px; border-radius: 6px; margin-right: 8px" slot="reference">
                            <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl"></el-image>
                            <div v-if="product.productType === 3"
                              style="position: absolute;
                              bottom: 8px;
                              background-color: #F7FCEB;
                              width: 100%;
                              height: 16px;
                              font-size: 12px;
                              line-height: 16px;
                              text-align:center;
                              color: #9AC331;">POD</div>
                            <div v-if="product.isOutOfStock === 1 || (['waiting_payment','abnormal_order'].includes(item.status) && [0,4].includes(product.skuStatus))" class="f-c-c" style="width: 70px; height: 70px; position: absolute; left: 0; top: 0; background: rgba(0, 0, 0, 0.37); border-radius: 6px; color: #f2f2f2; font-size: 12px">Out of Stock</div>
                          </div>
                        </el-popover>
                        <div class="imageInfo" style="width: 400px">
                          <el-tooltip effect="dark" :content="product.productName" placement="top">
                            <div v-if="+item.orderType === 5" class="ellipsis" style="padding:0;line-height:20px;width:100%">{{ product.productName }}</div>
                            <el-button v-else type="text" class="ellipsis" style="padding:0;line-height:20px;width:100%" @click="jumpDetailSeo(product.kkProductId)">{{ product.productName }}</el-button>
                          </el-tooltip>
                          <div>
                            <el-tooltip effect="dark" :content="product.options_render" placement="bottom">
                            <span class="ellipsis">{{ product.options_render }}</span>
                          </el-tooltip>
                          </div>
                          <div>
                            <span style="margin-right: 8px">${{ product.finalAmount }}</span>
                            <span v-if="product.price !== product.finalAmount" style="color: #747a87; font-size: 12px; text-decoration: line-through">${{ product.price }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="itemPrice f-c-c">
                      <span style="font-size: 14px; margin-right: 14px">X {{ product.productNum }}</span>
                      <span style="font-size: 16px; font-weight: bold">US${{ (product.finalAmount * product.productNum).toFixed(2) | numberKeepTwoDecimal }}</span>
                    </div>
                    <div class="statusTag f--c">
                      <div v-if="item.status === 'abnormal_order'">
                        <el-tooltip effect="dark" :content="item.notes ? item.notes.value : ''" placement="bottom-end">
                          <orderStatusTagVue :order="item" v-if="productIndex === 0"></orderStatusTagVue>
                        </el-tooltip>
                      </div>
                      <div v-else>
                        <orderStatusTagVue :order="item" v-if="productIndex === 0"></orderStatusTagVue>
                        <div class="orderStatusSubTip pointer">
                          <p v-if="+item.orderStatusSub === 1" @click="openOrderStatusSubTip(item)">{{ $t('Order.List.Components.AllStatus.RefundFailed') }}</p>
                          <p v-if="+item.orderStatus === 0 && +item.orderStatusSub === 4" @click="openOrderStatusSubTip(item)">{{ $t('Order.List.Components.AllStatus.AutoCheckoutFailed') }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="f--c" style="margin-left: 5px">
                      <el-tag effect="plain" class="pointer" type="danger" v-if="+item.orderStatusSub === 1" @click="openOrderStatusSubTip(item)">{{ $t('Order.List.Components.AllStatus.RefundFailed') }}</el-tag>
                      <el-tag effect="plain" class="pointer" type="danger" v-if="+item.orderStatusSub === 2" @click="openOrderStatusSubTip(item)">{{ $t('Order.List.Components.AllStatus.PartialRefund') }}</el-tag>
                      <el-tag effect="plain" class="pointer" type="danger" v-if="+item.orderStatusSub === 3" @click="openOrderStatusSubTip(item)">{{ $t('Order.List.Components.AllStatus.Refunded') }}</el-tag>
                    </div>
                  </template>
                </div>
                <div class="foldText f-b" v-if="item.orderItems.length > 1" @click="itemFoldClick(item)">
                  <el-button type="text">{{ item.orderItems.length }} {{ $t('Order.List.Components.AllStatus.Products') }}</el-button>
                  <i class="el-icon-arrow-down" style="line-height: 40px" v-if="!item.open"></i>
                  <i class="el-icon-arrow-up" style="line-height: 40px" v-if="item.open"></i>
                </div>
              </div>
              <div class="link_group">
                <el-button type="text" @click="tableHandleClick('detail', item)" class="link_button">{{ $t('orderList.ViewDetails') }}</el-button>
                <el-button v-if="!['waiting_payment', 'abnormal_order'].includes(item.status)" type="text" @click="tableHandleClick('addCart', item)" class="link_button">{{ $t('productDetail.addToCart') }}</el-button>

                <el-button v-if="item.cancelFulfillmentStatus === 'cancellation_requested'" type="text" class="link_button" @click="handleCancelDelivery(item)">{{ $t('orderList.CancelDelivery') }}</el-button>
                <template v-if="item.status === 'waiting_payment'">
                  <el-button round type="primary" @click="checkEmailBind(item)">{{ $t('orderList.PayNow') }}</el-button>
                </template>
                <template v-if="item.status === 'abnormal_order'">
                  <!-- <el-tooltip effect="dark" :content="item.notes ? item.notes.value : ''" placement="bottom-end"> -->
                    <el-button v-if="item.notes && item.notes.code===1" round type="danger" @click="updateAddressShow(item)">{{ $t('Order.List.Components.AllStatus.CompleteInformation') }}</el-button>
                    <el-button v-else-if="item.notes && item.notes.code && [2,3].includes(item.notes.code)" round type="primary" @click="checkEmailBind(item)">{{ $t('Order.Details.Components.TopTimeLine.GetLogistics') }}</el-button>
                    <!-- <el-button v-else round type="danger" @click="updateAddressShow(item)">{{ $t('Order.List.Components.AllStatus.CompleteInformation') }}</el-button> -->
                  <!-- </el-tooltip> -->
                </template>
              </div>
            </div>
          </div>
        </template>
        <emptyDataWithParams v-else></emptyDataWithParams>
      </div>
      <div style="text-align: right" v-if="listData.length">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-sizes="[20, 50, 100, 200]" :total="total" class="myPagination" :current-page.sync="searchParams.pageNumber" :page-size="searchParams.pageSize" @current-change="pageCurrentChange" @size-change="pageSizeChange" />
      </div>
    </template>
    <emptyNoStore v-else></emptyNoStore>
    <el-dialog :visible.sync="dialogConfirmVisible" width="500px" :before-close="ConfirmReceiptClose">
      <div class="f">
        <div style="margin-right: 4px">
          <i class="el-icon-question" style="color: #99c41c"></i>
        </div>
        <div>
          <div style="color: #99c41c; font-size: 18px; margin-bottom: 20px">
            {{ $t('orderList.ConfirmReceiptTitle') }}
          </div>
          <div>
            {{ $t('orderList.ConfirmReceiptContent') }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogConfirmVisible = false">{{ $t('orderList.cancel') }}</el-button>
        <el-button type="primary" @click="ConfirmReceiptSubmit">{{ $t('orderList.submit') }}</el-button>
      </span>
    </el-dialog>
    <trackingDialog ref="trackingDialog"></trackingDialog>
    <el-dialog :title="$t('Order.List.Components.AllStatus.ExportOrder')" :visible.sync="exportFailVisible" width="500px">
      <div style="text-align: center">
        <div>
          <i class="el-icon-error" style="font-size: 50px; color: #a6100c"></i>
        </div>
        <div style="font-weight: bold; font-size: 18px; line-height: 44px">{{ $t('Order.List.Components.AllStatus.ExportFailed') }}</div>
        <div style="font-weight: bold; font-size: 16px; line-height: 30px">{{ exportFailReason }}</div>
      </div>
      <span slot="footer" class="f-c-c">
        <el-button type="primary" @click="exportAgain">{{ $t('Order.List.Components.AllStatus.ExportAgain') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('Order.List.Components.AllStatus.AutoCheckout')" :visible.sync="bindCardFailVisible" width="500px">
      <div class="bind-card">
        <div class="f--c">
          {{ $t('Order.List.Components.AllStatus.AcceptedCardTypes') }}：
          <img src="@/assets/img/productDetail/card_1.png" alt="" />
          <img src="@/assets/img/productDetail/card_2.png" alt="" />
          <img src="@/assets/img/productDetail/card_4.png" alt="" />
        </div>
        <div class="text">
          <div>{{ $t('Order.List.Components.AllStatus.Tips4') }}</div>
          <div>{{ $t('Order.List.Components.AllStatus.Tips5') }}</div>
        </div>
      </div>
      <span slot="footer" class="f-c-c">
        <el-button type="primary" @click="jumpBandCard" style="padding: 12px 50px">{{ $t('Order.List.Components.AllStatus.AddACard') }}</el-button>
      </span>
    </el-dialog>
    <AddressDialog ref="AddressDialog" :addForm="addressForm" @orderAddressChange="updateAddress" :isOrderAddress="true"></AddressDialog>

    <el-dialog :title="$t('orderList.CancelDelivery')" :visible.sync="cancelDelivery.visibleCancelDelivery" width="600px">
      <div class="">
        <div style="font-weight: bold;line-height:30px">{{ $t('Order.List.Components.AllStatus.Tips6') }}</div>
        <div class="f--c">
          <i class="iconfont icon-error-warning-line" style="font-size:20px;margin-right:10px"></i>
          <div style="word-break:keep-all;">{{ $t('Order.List.Components.AllStatus.Tips7') }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="orderCancelFulfillment(1)">{{ $t('Order.List.Components.AllStatus.Agree') }}</el-button>
        <el-button type="primary" @click="orderCancelFulfillment(0)">{{ $t('Order.List.Components.AllStatus.Reject') }}</el-button>
      </div>
    </el-dialog>
    <AddCartStockout ref="addCartStockout" @affirmAddCart="addBatchCart"></AddCartStockout>
    <!-- 设置账号 -->
    <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
  </div>
</template>

<script>
import API from '@/api'
import bus from '@/util/bus'
import dayjs from 'dayjs'
import { downloadBlobFile } from '@/util/index.js'
import trackingDialog from './trackingDialog.vue'
import listTopFilter from './listTopFilter.vue'
import orderStatusTagVue from './orderStatusTag.vue'
import emptyNoStore from './emptyNoStore.vue'
import emptyDataWithParams from './emptyDataWithParams.vue'
import AddressDialog from '@/views/commodity/components/AddressDialog.vue'
import TemplateOne from '../../../index/album/components/TemplateOne.vue'
import _ from 'lodash'
import AddCartStockout from './AddCartStockout.vue'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'
export default {
  props: {
    orderStatus: String
  },
  components: {
    trackingDialog,
    listTopFilter,
    orderStatusTagVue,
    emptyNoStore,
    emptyDataWithParams,
    AddressDialog,
    TemplateOne,
    AddCartStockout,
    AccountSetting
  },
  data() {
    return {
      storesValue: '',
      statusValue: '',
      dateValue: [],
      searchParams: {
        pageSize: 20,
        pageNumber: 1
      },
      status: [],
      storeId: [],
      storeSelectList: [],
      total: 0,
      listData: [],
      ConfirmReceiptDialogKKOrderId: undefined,
      dialogConfirmVisible: false,
      searchContentStatus: false,
      trackingNumberVisible: false,
      trackingTimeLine: [],
      trackingNumberInfo: {
        trackingNumber: undefined,
        carrierCode: undefined
      },
      isAllChecked: false,
      selectionForPayNow: [],
      loadingContainer: null,
      exportFailVisible: false,
      exportFailReason: '',
      exportType: null, // 1 所有导出   2批量勾选导出
      ifAutomaticPayment: false, // 用户是否自动付款
      bindCardFailVisible: false,
      isEmptyDataAll: false, // 不带其他参数 且数据为空
      isEmptyDataWithParams: false, // 带其他参数 且数据为空
      addressForm: {},
      cancelDelivery: { // // 取消交运
        visibleCancelDelivery: false
      }
    }
  },
  computed: {
    CancellationReasonIsRequiredText() {
      return this.$t('orderList.CancellationReasonIsRequired')
    },
    RefundReasonIsRequiredtText() {
      return this.$t('orderList.RefundReasonIsRequired')
    },
    dialogTitleRefund() {
      let val = this.dialogCancelRefundTitle === 'Cancel Order' ? this.$t('orderList.CancelOrder') : this.$t('orderList.RefundReason')
      return val
    },
    statusSelectList() {
      let arr = [...this.$store.state.common.statusSelectList]
      if (arr.length < 2) {
        this.$store.dispatch('common/getStatusSelectList')
      }
      return arr
    },
    cancelReasonSelectList() {
      let arr = this.$store.state.common.cancelReasonSelectList
      if (!arr.length) {
        this.$store.dispatch('common/getCancelReasonSelectList')
      }
      return arr
    },
    platformOptions() {
      let arr = this.$store.state.common.platformOptions.map((e) => ({
        value: e.platformCode,
        label: e.platformName,
        level: 1,
        userId: this.$store.state.common.userId
      }))
      if (!arr.length) {
        this.$store.dispatch('common/getPlatformOptions')
      }
      return arr
    },
    orderIsHaveChoice() {
      return this.listData.some((e) => e.isChecked)
    },
    selectedTotalAmount() {
      return (
        this.selectionForPayNow.reduce((current, next) => {
          return current + next.totalAmount * 1000
        }, 0) / 1000
      )
    }
  },
  async created() {
    this.getUserInfo()
  },
  methods: {
    // 表格操作按钮
    tableHandleClick(type, item) {
      switch (type) {
        case 'detail':
          this.$router.push({
            path: '/order/details',
            query: {
              kkOrderId: item.kkOrderId,
              orderStatus: item.orderStatus
            }
          })
          break
        case 'cancel':
          this.dialogCancelRefundTitle = 'Cancel Order'
          this.dialogParams.kkOrderId = item.kkOrderId
          this.dialogCancelRefundVisible = true
          break
        case 'RequestRefund':
          this.dialogCancelRefundTitle = 'Refund Reason'
          this.dialogParams.kkOrderId = item.kkOrderId
          this.dialogCancelRefundVisible = true
          break
        case 'ConfirmReceipt':
          this.ConfirmReceiptDialogKKOrderId = item.kkOrderId
          this.dialogConfirmVisible = true
          break
        case 'FulfillOrder':
          this.$emit('FulfillOrder', item)
          break
        case 'addCart': {
          let skuList = _.cloneDeep(item.skuWarehouseItemList)
          let addCartList = []
          skuList.forEach(item => {
            if (!addCartList.length || !addCartList.some(t => (t.countryCode === item.countryCode && t.skuCode === item.skuCode))) {
              addCartList.push(item)
            } else {
              addCartList.forEach(t => {
                if (t.countryCode === item.countryCode && t.skuCode === item.skuCode) {
                  t.productNum += item.productNum
                }
              })
            }
          })
          let cartParams = addCartList.filter(t => +t.skuStatus === 1).map(item => ({
            kkProductId: item.kkProductId,
            num: item.productNum,
            skuCode: item.skuCode,
            warehouseCode: item.warehouseCode
          }))
          if (addCartList.some(t => t.skuStatus !== 1)) {
            this.$refs.addCartStockout.show(addCartList, cartParams)
            return
          }
          this.addBatchCart(cartParams)
          break
        }
        default:
          console.log(type)
          break
      }
    },

    // 加入购物车
    addBatchCart(cartParams) {
      if (!cartParams.length) {
        return this.$message.warning(this.$t('Order.List.Components.AllStatus.Tips8'))
      }
      API.addBatchCart({ cartParams }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(this.$t('promptText.msg19'))
      })
    },

    getParams() {
      const params = Object.assign({}, this.$refs.listTopFilter.getParams(), this.searchParams)
      return params
    },
    async getList(clearAllCheck) {
      this.isEmptyDataAll = false
      this.isEmptyDataWithParams = false
      if (clearAllCheck) {
        this.isAllChecked = false
        this.allCheck(false)
      }
      const params = this.getParams()
      const loading = this.$loading.service()
      try {
        const res = await API.orderGetList(params)
        if (res.code !== 10000) {
          this.$message.error(res.message)
          return
        }
        this.listData = res.data.list
        this.total = res.data.total
        this.listData.forEach((product) => this.itemHandle(product))
        /*
          判断是不是空状态
          只有在参数只有页码和页数且数据为空时才是空数据状态
        */
        let isEmptyDataAll = Object.keys(params).every((key) => {
          let type = Object.prototype.toString.call(params[key]).slice(8, -1)
          if (type === 'Array') return !params[key].length
          return !!params[key]
        })
        if (this.total === 0 && isEmptyDataAll) this.isEmptyDataAll = true
        if (this.total === 0 && !isEmptyDataAll) this.isEmptyDataWithParams = true
        loading.close()
        this.$nextTick(() => {
          document.documentElement.scrollTop = 0
        })
        return {
          activeName: this.orderStatus,
          total: this.total
        }
      } catch (error) {
        loading.close()
        this.$message.error(error.message)
        return {
          activeName: this.orderStatus,
          total: undefined
        }
      }
    },
    // 数据格式处理
    itemHandle(item) {
      // 2024.4.23  琼瑜提的需求暂时去掉
      // // 计算待支付是否过支付时间
      // if (item.status === 'waiting_payment' && item.purchaseDate && typeof item.purchaseDate === 'number' && ['KA'].includes(item.platformCode)) {
      //   let overTime = item.purchaseDate + 1000 * 60 * 60 * 24 * 5
      //   let currentTime = new Date().getTime()
      //   if (overTime < currentTime) {
      //     item.status = 'cancel'
      //   }
      // }
      // 图片格式转换
      item.orderItems.forEach((p) => {
        // 变体格式转换
        let options_render = ''
        JSON.parse(p.options).forEach((option) => {
          options_render += `${JSON.parse(option).value}、`
        })
        options_render = options_render.slice(0, -1)
        this.$set(p, 'options_render', options_render)
      })
      // 添加属性  数据展开折叠使用
      this.$set(item, 'orderItemRender', item.orderItems.slice(0, 1))
      this.$set(item, 'open', false)
      this.$set(item, 'isChecked', this.selectionForPayNow.findIndex((e) => e.kkOrderId === item.kkOrderId) !== -1)

      // 插入好评卡
      if (item.orderItems[0].attachmentSkuVos && item.orderItems[0].attachmentSkuVos.length && item.orderItems[0].attachmentSkuVos.some(t => t.type === 'Cards')) {
        let data = item.orderItems[0].attachmentSkuVos.filter(t => t.type === 'Cards')
        item.orderItems = [...item.orderItems, ...data]
      }
    },
    pageCurrentChange(page) {
      this.searchParams.pageNumber = page
      this.getList('clear')
    },
    resetPage() {
      this.searchParams.pageNumber = 1
      this.selectionForPayNow = []
      this.getList()
    },
    // 取消订单  拒绝收货弹窗关闭
    handleClose() {
      Object.keys(this.dialogParams).forEach((key) => {
        this.dialogParams[key] = undefined
      })
      this.dialogCancelRefundVisible = false
    },
    dialogConfirmCancelRefund() {
      if (this.dialogCancelRefundTitle === 'Cancel Order') {
        const params = new FormData()
        if (this.dialogParams.operationType === undefined || this.dialogParams.operationType === null) {
          this.$message.error(this.CancellationReasonIsRequiredText)
          return
        }
        Object.keys(this.dialogParams).forEach((key) => {
          if (this.dialogParams[key] !== undefined) params.append(key, this.dialogParams[key])
        })
        API.orderCancel(params)
          .then((res) => {
            this.$message.success(res.message)
            this.handleClose()
            this.getList()
            this.dialogCancelRefundVisible = false
          })
          .catch((err) => {
            let message = err.message || err.data.message
            this.$message.error(message)
          })
      } else if (this.dialogCancelRefundTitle === 'Refund Reason') {
        if (this.dialogParams.refundReason === undefined || this.dialogParams.refundReason === null) {
          this.$message.error(this.RefundReasonIsRequiredtText)
          return
        }
        const params = new FormData()
        Object.keys(this.dialogParams).forEach((key) => {
          if (this.dialogParams[key] !== undefined) params.append(key, this.dialogParams[key])
        })
        API.orderRefund(params)
          .then((res) => {
            this.$message.success(res.message)
            this.handleClose()
            this.getList()
            this.dialogCancelRefundVisible = false
          })
          .catch((err) => {
            let message = err.message || err.data.message
            this.$message.error(message)
          })
      }
    },
    // 确认收货
    ConfirmReceiptClose() {
      this.ConfirmReceiptDialogKKOrderId = undefined
      this.dialogConfirmVisible = false
    },
    // 确认收货确认
    ConfirmReceiptSubmit() {
      API.orderReceipt(this.ConfirmReceiptDialogKKOrderId)
        .then((res) => {
          this.dialogConfirmVisible = false
          this.$message.success(res.message)
          this.getList()
        })
        .catch((err) => {
          let message = err.message || err.data.message
          this.$message.error(message)
        })
    },
    checkEmailBind(row) {
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.payNowClick(row)
      }
    },
    // 打开支付弹窗
    payNowClick(row) {
      const { platformCode, totalAmount, kkOrderId, orderItems, orderType } = row
      row.productName = row.orderItems[0].productName
      row.productNum = row.orderItems[0].productNum
      row.skuCode = row.orderItems[0].skuCode
      const product = {
        productName: row.orderItems[0].productName,
        productNum: row.orderItems[0].productNum,
        skuCode: row.orderItems[0].skuCode,
        platformCode,
        totalAmount,
        kkOrderIds: [kkOrderId],
        orderItems,
        customer: row.customer,
        status: row.status,
        storeGroup: row.storeGroup,
        orderType: row.orderType
      }
      bus.$emit('showPayDialog', product)
    },
    checkEmailBindBatch() {
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.payNowClickBatch()
      }
    },
    payNowClickBatch() {
      // kkOrderId、totalAmount传所有 其他传第一个
      const kkOrderIds = this.selectionForPayNow.map((e) => e.kkOrderId)
      const totalAmount = this.selectionForPayNow.reduce((current, next) => {
        return current + next.totalAmount * 1000
      }, 0)
      const orderItemsMore = this.selectionForPayNow.map((e) => e.orderItems)
      const product = {
        productName: this.selectionForPayNow[0].orderItems[0].productName,
        productNum: this.selectionForPayNow[0].orderItems[0].productNum,
        skuCode: this.selectionForPayNow[0].orderItems[0].skuCode,
        platformCode: this.selectionForPayNow[0].platformCode,
        totalAmount: totalAmount / 1000,
        kkOrderIds,
        orderItemsMore
      }
      bus.$emit('showPayDialog', product, true)
    },
    // 平台店铺下拉
    cascaderChange(value) {
      if (value) {
        API.orderGetAllStore({ platformCode: value, userId: this.$store.state.common.userId, storeStatus: 1, authorizeStatus: 1 }).then((res) => {
          this.storeSelectList = res.data
        })
      }
      this.storeId = []
      this.resetPage()
    },
    // 列表折叠按钮
    itemFoldClick(item) {
      item.open = !item.open
      if (item.open) {
        item.orderItemRender = item.orderItems
      } else {
        item.orderItemRender = item.orderItems.slice(0, 1)
      }
    },
    dateChange(value) {
      if (value) {
        let from = dayjs(value[0].getTime()).format('YYYY-MM-DD HH:mm:ss')
        let to = dayjs(value[1].getTime()).format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.purchaseDateAt = from.replace(/[^\d:-]/g, '')
        this.searchParams.purchaseDateTo = to.replace(/[^\d:-]/g, '')
      } else {
        this.searchParams.purchaseDateAt = undefined
        this.searchParams.purchaseDateTo = undefined
      }
      this.resetPage()
    },
    pageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.getList()
    },
    statusType(statusName) {
      const statusMap = {
        'Waiting payment': 'warning',
        Pending: '',
        Delivered: '',
        Complete: 'success',
        'In refund': 'danger',
        Refunded: 'danger',
        Canceled: 'success',
        'payment processing': 'warning',
        'Partial Shipped': '',
        'waiting to ship': 'danger',
        'In Transit': 'info'
      }
      return statusMap[statusName]
    },
    getPoint() {
      document.body.scrollTop
    },
    orderDownloadInvoice(item) {
      API.orderDownloadInvoice(item.kkOrderId)
        .then((res) => {
          downloadBlobFile(res, `发票.pdf`)
        })
        .catch((err) => {
          downloadBlobFile(err.data, `发票.pdf`)
        })
    },
    showTrackingDialog(item) {
      this.$refs.trackingDialog.show(item)
    },
    itemCheck(item, value) {
      this.$set(item, 'isChecked', value)
      this.isAllChecked = this.listData.every((e) => e.isChecked)
      if (value) {
        this.selectionForPayNow.push(item)
      } else {
        let index = this.selectionForPayNow.findIndex((e) => e.kkOrderId === item.kkOrderId)
        index !== -1 && this.selectionForPayNow.splice(index, 1)
      }
    },
    allCheck(value) {
      this.selectionForPayNow = []
      this.listData.forEach((item) => {
        this.$set(item, 'isChecked', item.orderType === 5 ? false : value)
        // let index = this.selectionForPayNow.findIndex((e) => e.kkOrderId === item.kkOrderId)
        // if (value) {
        //   index === -1 && this.selectionForPayNow.push(item)
        // } else {
        //   index !== -1 && this.selectionForPayNow.splice(index, 1)
        // }
        if (item.isChecked) {
          this.selectionForPayNow.push(item)
        }
      })
    },
    openOrderStatusSubTip(item) {
      this.tableHandleClick('detail', item)
    },
    allExport(type) {
      const params = {
        fileType: 2,
        taskType: 14
      }
      if (type === 1) {
        const condition = this.$refs.listTopFilter.getParams()
        params.condition = JSON.stringify(condition)
      } else {
        if (!this.selectionForPayNow.length) return
        params.condition = JSON.stringify({ arrayIds: this.selectionForPayNow.map((e) => e.id) })
      }
      this.loadingContainer = this.$loading.service({
        text: 'Orders Exporting , Please wait'
      })
      const that = this
      this.exportType = type
      API.importExportFile(params).then((res) => {
        let id = res.data
        let fileStatus = 1
        let requestContainer = setInterval(() => {
          API.fileTaskById({ id }).then((result) => {
            fileStatus = result.data.fileStatus
            if (fileStatus === 3) {
              this.loadingContainer.close()
              if (result.data.fileResult === 1) {
                let url = result.data.fileResultPath
                const ele = document.createElement('a')
                ele.setAttribute('href', url)
                ele.setAttribute('id', 'exportEle')
                document.body.appendChild(ele)
                ele.click()
                document.body.removeChild(ele)
              } else {
                that.exportFailVisible = true
                that.exportFailReason = result.data.causesFailure
              }
              clearInterval(requestContainer)
              return
            } else if ([4, 5, 6].includes(fileStatus)) {
              this.loadingContainer.close()
              clearInterval(requestContainer)
              that.exportFailVisible = true
              that.exportFailReason = result.data.causesFailure
            } else {
              console.log('处理中')
            }
          })
        }, 5000)
      })
    },
    exportAgain() {
      this.exportFailVisible = false
      this.allExport(this.exportType)
    },
    switchPaymentHandle() {
      if (this.ifAutomaticPayment) {
        this.getPaymentPaymentConsent()
        return
      }
      this.$confirm('Are you sure you want to turn off Auto Checkout?', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.setAutomaticPayment(this.ifAutomaticPayment)
        })
        .catch(() => {
          this.$set(this.$data, 'ifAutomaticPayment', !this.ifAutomaticPayment)
        })
    },
    getUserInfo() {
      API.getUserInfo(this.$store.state.common.userId).then((res) => {
        this.$set(this.$data, 'ifAutomaticPayment', !!res.data.ifAutomaticPayment)
      })
    },
    // 编辑自动支付状态
    setAutomaticPayment(status) {
      API.setAutomaticPayment(status ? 1 : 0)
    },
    // 绑卡列表
    getPaymentPaymentConsent() {
      API.getPaymentPaymentConsent().then((res) => {
        if (res.data && res.data.length) this.setAutomaticPayment(this.ifAutomaticPayment)
        else {
          this.bindCardFailVisible = true
          this.setAutomaticPayment(this.ifAutomaticPayment)
        }
      })
    },
    jumpBandCard() {
      this.$router.push('/personal-center/payment-manage?type=bank_card')
    },
    updateAddress(addressForm) {
      const { countryCode: country, city, phoneNumber: phone, fullName: recipient, streetAddressLine1: street1, streetAddressLine2: street2, province, zipCode: zip } = addressForm
      const params = {
        data: {
          orderAddresses: {
            country,
            city,
            phone,
            recipient,
            street1,
            street2,
            province,
            zip
          },
          paymentMethod: 0
        },
        kkOrderId: this.addressForm.kkOrderId
      }
      API.orderChangeAddress(params)
        .then((res) => {
          this.$message.success(res.message)
          this.addressForm = {}
          this.getList()
        })
        .catch((err) => {
          this.$message.error(err.data.data)
        })
    },
    updateAddressShow(item) {
      API.orderGetDetail(item.kkOrderId).then(res => {
        const { city, country: countryCode, phone: phoneNumber, province, street1: streetAddressLine1, street2: streetAddressLine2, zip: zipCode } = res.data.address
        this.addressForm = { city, countryCode, phoneNumber, province, streetAddressLine1, streetAddressLine2, zipCode, fullName: item.customer, kkOrderId: item.kkOrderId }
        this.$refs.AddressDialog.show()
      })
    },
    // 取消交运
    handleCancelDelivery(item) {
      // this.$set(this.$data, '')
      this.cancelDelivery = {
        visibleCancelDelivery: true,
        ...item
      }
    },
    // 前台-接受or拒绝客户发起的取消交运请求(Shopify订单)
    orderCancelFulfillment(accept) {
      API.orderCancelFulfillment({
        storeId: this.cancelDelivery.storeId,
        storeOrderId: this.cancelDelivery.storeOrderId,
        accept
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.cancelDelivery = {
          visibleCancelDelivery: false
        }
        this.$message.success(this.$t('common.success'))
      })
    },
    // 绑定邮箱成功回调
    setSuccess() {
      if (this.selectionForPayNow.length) {
        this.payNowClickBatch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bind-card {
  margin-top: -20px;
  img {
    width: 40px;
  }
  .text {
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    color: #8b93a3;
    width: 304px;
  }
}
.selectSelf {
  margin-right: 8px;
  width: 150px;
  /deep/input {
    border-radius: 30px;
  }
}
.inputGroup {
  /deep/.el-input__inner {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
  /deep/.el-input-group__append {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    background-color: rgba(153, 196, 28, 0.2);
  }
}
.orderGroup_item {
  margin: 0 20px 10px;
  .left {
    > div {
      font-size: 14px;
      font-weight: 500;
      > div:nth-of-type(2) {
        color: #747a87;
      }
    }
  }
  > div:first-of-type {
    .info {
      > div {
        > div {
          height: 24px;
          line-height: 24px;
        }
        > div :first-of-type {
          font-weight: 500;
        }
        > div:nth-of-type(2) {
          color: #747a87;
        }
      }
    }
  }
  .detailInfo {
    .imageInfo {
      > div {
        font-size: 14px;
        color: #10141d;
        margin-bottom: 4px;
        font-weight: 400;
      }
    }
    .itemPrice {
      position: relative;
      width: 180px;
      text-align: center;
      .haveDiscount {
        position: absolute;
        top: 16px;
        left: 0;
        right: 0;
        font-size: 14px;
        color: gray;
        text-decoration: line-through;
      }
    }
    .statusTag {
      position: relative;
      width: 160px;
      margin-left: 60px;
      .trackingNumber {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
      .orderStatusSubTip {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -10px;
        min-width: 300px;
        font-size: 12px;
        color: red;
        text-align: center;
      }
    }
  }
  .foldText {
    width: 110px;
    margin: 10px 20px;
    cursor: pointer;
  }
}
.orderGroup_item::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #cdd4dd;
  transform: scaleY(0.5);
}
.myTabs {
  /deep/.el-tabs__header {
    padding-left: 20px;
  }
}
.myPagination {
  padding: 8px 5px;
  /deep/.number {
    border: 1px solid #d9d9d9;
    margin: 0 5px;
    padding: 0;
    min-width: 30px;
  }
}
.requiredLabel::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.requireText {
  width: 160px;
  text-align: right;
  height: 40px;
  line-height: 40px;
}
.link_group {
  width: 200px;
  margin-right: 20px;
  text-align: right;
  height: 96px;
  padding-top: 10px;
  > div:first-of-type {
    margin-top: 30px;
  }
  .link_button {
    width: 100px;
    margin-left: 0px;
    padding-bottom: 0px;
  }
  /deep/.el-button {
    margin-top: 8px;
  }
  .AbnormalOrderBtn {
    margin-top: 24px !important;
  }
}
.inputPlaceholder {
  /deep/input::placeholder {
    font-weight: 400;
  }
}
/deep/.el-tag {
  border-radius: 14px;
}
/deep/.el-tag::before {
  content: '';
  display: inline-block;
  margin: 0 4px 2px 0;
  width: 4px;
  height: 4px;
  line-height: 28px;
  background: #99c41c;
  border-radius: 100%;
}
/deep/.el-tag--warning::before {
  background-color: #e6a23c;
}
/deep/.el-tag--info::before {
  background-color: #909399;
}
/deep/.el-tag--danger::before {
  background-color: #f56c6c;
}
.violetStatus {
  background-color: rgb(251, 245, 255);
  color: rgb(167, 78, 239);
}
.violetStatus::before {
  background-color: rgb(167, 78, 239);
}
.soldOutLabel {
  display: inline-block;
  width: 62px;
  height: 17px;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  line-height: 17px;
  color: #828282;
  background: #d9d9d9;
  border-radius: 2px;
}
.topComponent {
  .autoCheckoutSwitch {
    /deep/.el-switch__core {
      height: 32px;
      border-radius: 14px;
    }
    /deep/.el-switch__core::after {
      height: 28px;
      width: 28px;
    }
    /deep/.is-checked {
      /deep/.el-switch__core::after {
        margin-left: -30px !important;
      }
    }
  }
}
.AbnormalOrderTip {
  color: #e53353;
  background-color: rgba(229, 51, 83, 0.04);
  margin: 0 20px 4px;
  padding: 13px 10px;
}
.payNowBatch{
  height: 36px;
  // line-height: 36px;
  background-color: rgba(235, 243, 210, 0.37);
  color: #99C41C;
  padding: 6px 10px;
  margin-right: 20px;
  border-radius: 40px;
}
</style>

<style lang="scss">
.topComponent {
  .is-checked {
    .el-switch__core::after {
      margin-left: -30px !important;
    }
  }
}
</style>

<style lang="scss">
.partsTable {
  font-family: 'Poppins';
  font-size: 14px;
  > p {
    margin-bottom: 14px;
    font-weight: bold;
  }
  .productBox {
    margin-bottom: 12px;
    .imageBox {
      margin-right: 12px;
    }
    .info {
    }
  }
}
.partsTag {
  position: absolute;
  right: -70px;
  top: -4px;
}
.myAttachemtIcon:hover {
  background-color: #f9fcf2;
}
</style>
